export default function NotesCard({ notes, isCollapsed, onToggle }) {
  if (!notes || notes.length === 0) return null;

  return (
    <div className={`generation-notes ${isCollapsed ? "collapsed" : ""}`}>
      <h2 className="notes-toggle" onClick={onToggle}>
        Notes
        <span className="toggle-icon">▼</span>
      </h2>
      <div className="notes-content">
        <ul>
          {notes.map((note, i) => (
            <li key={i}>{note}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
